import { useTranslation } from 'react-i18next';

import { useInvalidateAccountLegalEntityQuery } from '@/entities/account';
import {
  putAccountLegalEntity,
  UpsertLegalEntityRequest,
} from '@/shared/api/account';
import { useAppMutation } from '@/shared/lib/useAppMutation';
import { useNotifications } from '@/shared/ui/Notifications';

export function useUpdateLegalEntity() {
  const { t } = useTranslation();
  const invalidateLegalEntity = useInvalidateAccountLegalEntityQuery();
  const { addNotification } = useNotifications();

  const mutation = useAppMutation({
    mutationFn: (vars: UpsertLegalEntityRequest) => putAccountLegalEntity(vars),
    onSettled: async () => {
      await invalidateLegalEntity();
    },
    onError: (error) => {
      addNotification({
        type: 'error',
        title: error.message,
        caption: error.data?.details,
      });
    },
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: t('settings:legalEntity.saved'),
      });
    },
  });

  return {
    updateLegalEntity: mutation.mutateAsync,
    ...mutation,
  };
}
